import { connect } from 'react-redux';

import decorate from '../../../../utils/decorate';

import BetSearchResults from './BetSearchResults.jsx';

import injectPermissions from '../../../../utils/permissionsInject';

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {}
}

export default decorate(
    connect(injectPermissions(mapStateToProps), mapDispatchToProps),
    BetSearchResults
);
